// extracted by mini-css-extract-plugin
export default {"container":"styles_container__judd2","container__info":"styles_container__info__Slo8m"};